export default __webpack_public_path__ + "static/media/Radiotoren+topkoeling.bdb732f7.png";